export default "__VITE_PUBLIC_ASSET__f4ca3a08__"